import React, { useEffect, useState } from 'react';
import Constants from "../../../helper/Constants";
import { useObjCommonFilterStore } from "../../../hooks/objCommonFilter";
import Helper from '../../../helper/Helper';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

function SearchCompliance() {
    const defaultModel = { searchText: "" };
    const [searchBy, setSearchBy] = useState("")
    const [searchData, setSearchData] = useState(defaultModel);
    const [clearFilter, setClearFilter] = useState(true);
    const [{ filter_list }, { }, { set_filter_list,clear_all_filter }] = useObjCommonFilterStore();
    const [{ }, { system_alert_indicator, clear_all_system_alert }, { }] = useDOMAttachToSystemStore();

    useEffect(() => {
        if ((!filter_list || Object.entries(filter_list).length === 0) && clearFilter) {
            setSearchData(defaultModel);
            setSearchBy('');
            clear_all_system_alert({});
        }else if ((!filter_list || Object.entries(filter_list).length === 0)) {
            setSearchData(defaultModel);
        }  else {
            setSearchData({
                searchText: filter_list?.searchText?.searchKeyword || '',
            });
            setSearchBy(filter_list?.searchText?.key || '');
        }
    }, [filter_list]);

    const onSearch = (e) => {
        e.preventDefault();
        clear_all_system_alert({})
        if(Object.entries(filter_list).length != 0){
            clear_all_filter()
        }
        if (!searchData?.searchText || !searchBy) {
            setClearFilter(false)
            system_alert_indicator({
                name: 'complianceManager',
                message: "You must enter some search criteria.",
                type: "danger",
                isDisplayIcon: true,
                isDisplay: false,
            })
            setSearchData(defaultModel)
            return false;
        }

        const keyToSearchType = {
            orderNumber: "Web Order Number",
            customerNumber: "Customer Number",
            customerName: "Customer Name",
        };
        const filterList = Object.entries(searchData)
            .filter(([key, value]) => Helper.valueIsNotNull(key)).map((v) => {
                return {
                    searchType: keyToSearchType[searchBy],
                    key: searchBy,
                    searchKeyword: v[1],
                };
            });
        const filterListObject = filterList?.reduce((acc, curr) => {
            acc['searchText'] = curr;
            return acc;
        }, {});
        setClearFilter(true)
        set_filter_list(filterListObject);

    };
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setSearchData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    return (
        <>
            <div className='acsearchuser'>
                <div className='bg-grey2'>
                    <div className='container'>
                        <div className="accordion-item ">
                            <h2 className="accordion-header" id="searchInput">
                                <button className="accordion-button" type="button" data-toggle="collapse"
                                    data-target="#collapseSearch" aria-expanded="true" aria-controls="collapseOne">
                                    <b className="font-16">Search</b>
                                </button>
                            </h2>

                            <div id="collapseSearch" className="accordion-collapse collapse in"
                                aria-labelledby="searchInput"
                                data-parent="#accordionExample">
                                <div className="accordion-body p-0">

                                    <form
                                        onSubmit={(e) => {
                                            onSearch(e);
                                        }}>
                                        <div className='orderadmin-search'>
                                            <div className='orderadmin-search-content'>
                                                <div className="row bs5">
                                                    <div className="col-sm-12 col-md-6 mb-2">
                                                        <label htmlFor="searchBy">Search By</label>
                                                        <div className='selectbox'>
                                                            <select
                                                                id="searchBy"
                                                                className="form-control form-control-sm"
                                                                name="searchBy"
                                                                value={searchBy || ""}
                                                                onChange={(e) => {
                                                                    setSearchBy(e.target.value);
                                                                    setSearchData(defaultModel);
                                                                }}
                                                            >
                                                                <option value={""}>--Select--</option>
                                                                {Object.entries(Constants.AdminComplianceOptions).map(([key, value]) => (
                                                                    <option key={key} value={key}>{value}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-12 col-md-6 mb-2">
                                                        <label className=''
                                                            htmlFor='searchText'></label>
                                                        <input
                                                            className="ps-2 form-control form-control-sm mb-0"
                                                            name="searchText"
                                                            placeholder="Search By"
                                                            type="text"
                                                            value={searchData.searchText}
                                                            disabled={!searchBy}
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>


                                                </div>
                                            </div>
                                            <div className=" text-sm-end mt-3 pe-0">
                                                <button className="btn btn-secondary bs5 w140 font-bold">Search</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>);
}


export default SearchCompliance;